<template>
  <div class="m-common__review__item--header">
    <a :href="itemDetailUrl">
      <figure class="review__item__thumb"><img :src="itemImageUrl" alt="" /></figure>
      <p class="review__item__title">{{ itemName }}</p>
      <ul>
        <li class="review__item__rating">
          <span class="star-wrap star-size-12"><span :class="averageNumber | formatRatingClassName('star-')">{{ averageNumber | formatRating }}</span></span>
          <span class="rating-num">5つ星のうち<span class="num">{{ averageNumber }}</span></span>
        </li>
        <li class="review__item__count"><span>{{ count }}</span>件のレビュー</li>
      </ul>
    </a>
  </div>
</template>

<script>
import urls from '@/mixins/urls'
export default {
  name: 'BaseReviewRatingAverageSimple',
  mixins: [ urls ],
  props: {
    average: {
      type: String,
      default: ''
    },
    count: {
      type: Number,
      default: 0
    },
    skuCode: {
      type: String,
      required: true
    },
    itemName: {
      type: String,
      default: ''
    }
  },
  computed: {
    averageNumber () {
      return Math.round(Number(this.average) * 10) / 10
    },
    /* averageLabel () {
      return Math.round(Number(this.average) * 10) / 10
    }, */
    itemDetailUrl () {
      return this.getItemDetailUrl(this.skuCode)
    },
    itemImageUrl () {
      return this.getItemImageUrl(this.skuCode)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/BaseReviewRatingAverageSimple.vue